<template>

<footer>
    <div class="footer_ad">
        <div class="center">
            <ul>
                <li v-for="(v,i) in adArr" :key="i">
                    <span class="adImg" :style="`background-position-y: ${adImgY[i]}px;`"></span>
                    <div>
                        <div>{{ v.title }}</div>
                        <div>{{ v.content }}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="footer_menu">
        <div class="center">
            <div>
                <div>
                    <ul v-for="(value,index) in menuArr" :key="index">
                        <li class="title">{{ value.title }}</li>
                        <li class="menu" v-for="(v,i) in value.menuChild" :key="i" @click="$router.push({path:v.link})">{{ v.title }}</li>
                    </ul>
                </div>
                <div class="customer_service">
                    <div>020-37092033</div>
                    <div>周一至周日 9:00-22:00</div>
                    <div>在线客服</div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer_main_menu">
        <div class="center">
            <div>
                <ul>
                    <li v-for="(v,i) in mainMenuArr" :key="i" @click="$route.push({path:v.link})">{{ v.title }}</li>
                </ul>
            </div>
            <div>
                <ul>
                    <li><a href="https://beian.miit.gov.cn" target="_blank">粤ICP备11096557号</a></li>
                    <li>版权所有©2020广州印特丽科技有限公司</li>
                </ul>
            </div>
        </div>
    </div>
</footer>

</template>

<script>
export default{
    name:"homeFooter",
    data(){
        return{
            // 底部广告数据
            adArr:[
                {title:"免费设计",content:"满99元免费设计"},
                {title:"品质保证",content:"无条件退换"},
                {title:"实体店铺",content:"信用保证"},
                {title:"无忧售后",content:"全程客服"},
            ],
            adImgY:[-22,-120,-210,-300],
            // 底部菜单数据
            menuArr:[
                {title:"帮助中心",menuChild:[
                    {title:"新手指南",link:"/"},
                    {title:"配送方式及费用",link:"/"},
                    {title:"常见问题",link:"/"}
                ]},
                {title:"印刷知识",menuChild:[
                    {title:"上传须知",link:"/"},
                    {title:"关于色差",link:"/"},
                    {title:"印品限制",link:"/"},
                    {title:"印刷工艺",link:"/"},
                ]},
                {title:"会员体系",menuChild:[
                    {title:"会员成长体系",link:"/"},
                    {title:"大客户专区",link:"/"},
                    {title:"会员充值",link:"/"},
                ]},
                {title:"购买须知",menuChild:[
                    {title:"充值支付",link:"/"},
                    {title:"产品退换",link:"/"},
                    {title:"印前必看",link:"/"},
                ]}
            ],
            // 底部主菜单
            mainMenuArr:[
                {title:"公司简介",link:"/"},
                {title:"联系我们",link:"/"},
                {title:"服务声明",link:"/"},
                {title:"招聘信息",link:"/"},
                {title:"媒体报道",link:"/"},
            ],
        }
    }
}
</script>

<style lang="less" scoped>
footer{
    .footer_ad{
        background-color: white;
        ul{
            display: flex;
            justify-content: space-between;
            padding: 25px 100px;
            li{
                display: flex;
                justify-content: space-around;
                align-items: center;
                >.adImg{
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    display: inline-block;
                    background-image:url('../../public/images/commit_1.png');
                    background-repeat: no-repeat;
                    background-position-x: -14px;
                }
                >div{
                    text-align: left;
                    >div{
                        &:first-child{
                            font-size: 22px;
                            margin-bottom: 6px;
                        }
                        &:last-child{
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
    .footer_menu{
        background-color: #212121;
        color: #666;
        >div{
            >div{
                display: flex;
                padding: 25px 100px;
                justify-content: space-between;
                >div:first-child{
                    display: flex;
                    justify-content: space-between;
                    text-align: left;
                    width: calc( 100% - 305px );
                    ul{
                        li{
                            margin-bottom: 14px;
                            cursor: pointer;
                            &:first-child{
                                color: #ccc;
                                font-size: 16px;
                                cursor: default;
                            }
                            &:last-child{
                                margin-bottom: 0;
                            }
                            &:hover{
                                color: #ccc;
                            }
                        }
                    }
                }
                >.customer_service{
                    align-self: center;
                    width: 205px;
                    >div{
                        &:first-child{
                            color: #fff;
                            margin-bottom: 10px;
                            font-size: 24px;
                        }
                        &:last-child{
                            width: 126px;
                            height: 34px;
                            box-sizing: border-box;
                            border-radius: 5px;
                            margin: 8px auto;
                            line-height: 34px;
                            color: #fff;
                            background-color: #c41b20;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

    .footer_main_menu{
        background-color: #c41b20;
        padding: 4px 0;
        color: #fff;
        >div{
            >div{
                &:first-child{
                    margin-bottom: 6px;
                    li{
                        width: 92px;
                        height: 18px;
                        line-height: 18px;
                        cursor: pointer;
                        position: relative;
                        display: inline-block;
                        &::after{
                            content: "";
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translate(-50%,-50%);
                            width: 1px;
                            height: 14px;
                            background-color: rgba(255, 255, 255, .8);
                        }
                        &:last-child::after{
                            content: none;
                        }
                    }
                }
                &:last-child{
                    li{
                        height: 18px;
                        line-height: 18px;
                        display: inline-block;
                        &:first-child{
                            width: calc( 92px * 2 );
                            position: relative;
                            >a{
                                color: #fff;
                            }
                            &::after{
                                content: "";
                                position: absolute;
                                right: 0;
                                top: 50%;
                                transform: translate(-50%,-50%);
                                width: 1px;
                                height: 14px;
                                background-color: rgba(255, 255, 255, .8);
                            }
                        }
                        &:last-child{
                            width: calc( 92px * 3 );
                        }
                    }
                }
            }
        }
    }
}
</style>